module.exports = __webpack_public_path__ + "img/truckTrailerFrontRightOutline.912dac94.svg";